import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

import { errorMessages } from '@/constants/messages'
import { useIsMatchCriteriaEnabledForUser } from '@/hooks/useCurrentUserMatchCriteria'
import { useIsCoupang } from '@/hooks/useIsCoupang'
import { useGetConfigQuery } from '@/slices/config'

import { isAlternativeUnitTypeSameAsUnitType } from './helpers'

import type { AccommodationFormData } from '../../types'

export const useOptionalInformationFormSection = () => {
  const methods = useFormContext<AccommodationFormData>()
  const { isMatchCriteriaLoading, isMatchCriteriaEnabled } =
    useIsMatchCriteriaEnabledForUser()
  const { data: config } = useGetConfigQuery()
  const configSortOptions = config?.horSortList?.items || []
  const {
    control,
    register,
    watch,
    formState: { errors },
    setValue,
  } = methods
  const airportTransferChecked = watch('airportTransferChecked')

  useEffect(() => {
    if (!airportTransferChecked) {
      setValue('airportTransfer', null)
      setValue('airportTransferInformation', null)
    }
  }, [airportTransferChecked])

  const shouldShowWelcomePack = useIsCoupang(methods.watch)

  const sortOptions =
    (!isMatchCriteriaLoading && isMatchCriteriaEnabled
      ? configSortOptions
      : configSortOptions?.filter((option) => option?.value !== 4)) || []

  useEffect(() => {
    // Only for new HORs: stick to top match sort option when client setting enabled
    if (!isMatchCriteriaLoading) {
      methods.setValue('sortType', isMatchCriteriaEnabled ? 4 : 0)
    }
  }, [isMatchCriteriaEnabled, isMatchCriteriaLoading])

  const isAlternativeUnitTypeValid = (value: string) => {
    if (
      isAlternativeUnitTypeSameAsUnitType(value, methods.getValues('bedrooms'))
    ) {
      return errorMessages.alternativeUnitTypeSameAsUnitType
    }
    return true
  }

  return {
    airportTransferChecked,
    control,
    errors,
    register,
    sortOptions,
    isAlternativeUnitTypeValid,
    shouldShowWelcomePack,
  }
}
